import { OptimizelyFeatureFlags } from '@tgg/common-types';

import { useFlagsContext } from '../../contexts';
import { withVerticalSpacing } from '../../hocs/withVerticalSpacing/withVerticalSpacing';

import { StyledHeading } from './Heading.styled';
import { HeadingProperties } from './Heading.types';

/**
 * Use the `Heading` component to communicate the organisation of the content of the page.
 */
function HeadingComponent({
    id,
    variant = 'h1',
    alignOnDesktop,
    gutterBottom = true,
    children,
    component,
    className,
    color,
    addPageContainerStyling = false,
    branchId,
    gymName,
    isLowercase = true,
    ...otherProperties
}: HeadingProperties) {
    const {
        flags: {
            [OptimizelyFeatureFlags.REBRANDING]: { enabled: isRebrand },
        },
    } = useFlagsContext();

    if (!children) {
        return null;
    }

    const finalVariant = isRebrand && variant === 'h1' ? 'h1Rebrand' : variant;

    return (
        <StyledHeading
            id={id}
            gutterBottom={gutterBottom}
            variant={finalVariant}
            component={component}
            className={className}
            $color={color}
            $alignOnDesktop={alignOnDesktop}
            $addPageContainerStyling={addPageContainerStyling}
            $isLowercase={isRebrand ? false : isLowercase}
            {...otherProperties}
        >
            {children}
        </StyledHeading>
    );
}

export const Heading = withVerticalSpacing(HeadingComponent);
